import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function Navigation({ currentCount, setCurrentCount, totalPages }) {
  const questions = useSelector((state) => state.questions.questions);
  const navigate = useNavigate();
  const nextCount = parseInt(currentCount) + 1;
  const prevCount = parseInt(currentCount) - 1;

  const prevCountLogic = prevCount < 1;
  const nextCountLogic = nextCount > totalPages;

  const goToNext = () => {
    if (nextCount <= totalPages) {
      setCurrentCount(nextCount); // Update the state
      navigate(`/view/${nextCount}`);
    }
  };

  const goToPrevious = () => {
    if (prevCount >= 1) {
      setCurrentCount(prevCount); // Update the state
      navigate(`/view/${prevCount}`);
    }
  };

  if (totalPages <= 1) {
    return null; // Return nothing if questions array is empty
  }

  // Create pagination indicators
  const renderPaginationDots = () => {
    const dots = [];
    for (let i = 1; i <= totalPages; i++) {
      dots.push(
        <div 
          key={i} 
          className={`pagination-dot ${i === parseInt(currentCount) ? 'active' : ''}`}
          onClick={() => {
            setCurrentCount(i);
            navigate(`/view/${i}`);
          }}
        />
      );
    }
    return dots;
  };

  return (
    <div className='navigation-wrapper'>
      <div className='pagination-progress'>
        <div className='pagination-info'>
          Question {currentCount} of {totalPages}
        </div>
        <div className='pagination-dots'>
          {renderPaginationDots()}
        </div>
      </div>
      <div className='button-container'>
        <button
          onClick={goToPrevious}
          className={`previous-button ${prevCountLogic ? 'button-disabled' : ''}`}
        >
          Previous
        </button>
        <button
          onClick={goToNext}
          className={`next-button ${nextCountLogic ? 'button-disabled' : ''}`}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Navigation;
